export default function socialBtn($container, { url }) {
  const btnClick = e => {
    e.preventDefault()
    const left = window.screen.width / 2 - 600 / 2
    const top = window.screen.height / 2 - 440 / 2
    window.open(
      url,
      '',
      `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=600,height=440,top=${top},left=${left}`
    )
  }
  $container.addEventListener('click', btnClick)
  return () => $container.removeEventListener('click', btnClick)
}



// WEBPACK FOOTER //
// ./src/js/components/social-btn.js